import React, { useState, useEffect } from "react";
import { Header2 } from "../components/elements/Header";
import { DropDownList, ListItem } from "../components/elements/List";
import styled from "styled-components";
import { useAuth } from "../context/auth";
import axios from "axios";
import authHeader from "../services/auth.header";
import Popup from "reactjs-popup";
import UnitPrompt from "../components/prompts/UnitPrompt";
import CurrencyPrompt from "../components/prompts/CurrencyPrompt";

const BackBtn = styled.button`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: bold;
  font-size: 2vh;
  text-align: center;
  letter-spacing: 0.005em;
  color: #fdfffc;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: 20px;
  right: 3.57%;
  margin-top: 20px;
`;

const Indicator = styled.h1`
  &:hover {
    color: #fd9e46;
  }
  margin-right: 25px;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  color: #fffcf2;
`;

const StyledPopup = styled(Popup)`
  &-overlay {
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    background-color: rgba(4, 3, 3);
  }
  &-content {
    color: #fdfffc;
    bottom: auto !important;
    top: 0px !important;
    overflow: auto;
    right: auto;
    height: 100%;
    width: 100%;
    left: 0px !important;
    outline: none;
    padding-bottom: 10px;
  }
`;

export default function Settings(props) {
  const { user } = useAuth();
  const myr = "myr";
  const usd = "usd";
  const us = "us";
  const metric = "metric";
  const [currency, setCurrency] = useState("Malaysia(MYR)");
  const [unit, setUnit] = useState("");
  const [curValue, setCurValue] = useState("");
  const [bodyProfile, setBodyProfile] = useState(null);
  const [currencyList, setCurrencyList] = useState([]);
  const [open, setOpen] = useState(false);
  const BASE_URL = "https://catway.services.ombre.app/v1/";

  useEffect(() => {
    getProfile();
  }, []);

  useEffect(() => {
    getSetting();
  }, []);

  useEffect(() => {
    getCurrencyList();
  }, []);

  const getCurrencyList = () => {
    return axios
      .get(" https://settings.services.ombre.app/v1/currency/list", {
        headers: authHeader(),
      })
      .then((response) => {
        setCurrencyList(response.data.data);
      });
  };

  const getProfile = () => {
    return axios
      .get(
        BASE_URL +
          "users/" +
          `${user && user.data ? user.data.id : user.id}` +
          "/profile",
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        setBodyProfile(response.data);
      });
  };

  const getSetting = () => {
    return axios
      .get(
        BASE_URL +
          "users/" +
          `${user && user.data ? user.data.id : user.id}` +
          "/profile" +
          "/settings",
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        setCurValue(response.data.data.currency);
      });
  };

  const updateUnit = (data) => {
    return axios.put(
      BASE_URL +
        "users/" +
        `${user && user.data ? user.data.id : user.id}` +
        "/profiles/" +
        bodyProfile.data.id,
      {
        unit: data,
      },
      {
        headers: authHeader(),
      }
    );
  };

  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  return (
    <>
      <Header2 style={{ marginTop: "70px" }}>Settings</Header2>

      <div style={{ marginTop: "40px" }}>
        <DropDownList>
          <ListItem>
            <div className="d-flex justify-content-between">
              <div style={{ marginLeft: "25px" }}>Currency</div>
              <div>
                <StyledPopup
                  trigger={<Indicator>{curValue.toUpperCase()}</Indicator>}
                  arrow="false"
                  nested
                >
                  <>
                    <BackBtn>
                      <i class="fa fa-arrow-left"></i>
                    </BackBtn>
                    <Header2>Currency</Header2>
                    <div style={{ padding: "25px" }}>
                      <DropDownList>
                        {currencyList.map((list, i) => (
                          <ListItem
                            value={list.code}
                            onClick={(e) => {
                              e.preventDefault();
                              setCurrency(list.code);
                              setOpen(true);
                            }}
                          >
                            <div className="d-flex row">{list.name}</div>
                          </ListItem>
                        ))}

                        <StyledPopup open={open}>
                          <CurrencyPrompt currency={currency} />
                        </StyledPopup>
                      </DropDownList>
                    </div>
                  </>
                </StyledPopup>
              </div>
            </div>
          </ListItem>
          <ListItem>
            <div className="d-flex justify-content-between">
              <div style={{ marginLeft: "25px" }}>Unit of measurement</div>
              <div>
                <StyledPopup
                  trigger={
                    bodyProfile ? (
                      //capitalize unit
                      <Indicator>{capitalize(bodyProfile.data.unit)}</Indicator>
                    ) : (
                      <Indicator>INT</Indicator>
                    )
                  }
                  arrow="false"
                  nested
                >
                  <>
                    <BackBtn>
                      <i class="fa fa-arrow-left"></i>
                    </BackBtn>
                    <Header2>Unit Measurement</Header2>
                    <div style={{ padding: "25px" }}>
                      <DropDownList>
                        <ListItem value="metric">
                          <div
                            className="d-flex row"
                            value={metric}
                            onClick={() => updateUnit(metric)}
                          >
                            Metric
                          </div>
                        </ListItem>
                        <ListItem>
                          <div
                            className="d-flex row"
                            value={us}
                            onClick={() => updateUnit(us)}
                          >
                            US
                          </div>
                        </ListItem>
                      </DropDownList>
                    </div>
                  </>
                </StyledPopup>
              </div>
            </div>
          </ListItem>
          <ListItem>
            <div
              style={{ marginLeft: "25px" }}
              className="d-flex row"
              onClick={() => {
                openInNewTab("https://www.ombre.me/terms-and-condition");
              }}
            >
              Terms and conditions
            </div>
          </ListItem>
          <ListItem>
            <div
              style={{ marginLeft: "25px" }}
              className="d-flex row"
              onClick={() => {
                openInNewTab("https://www.ombre.me/privacy-policy");
              }}
            >
              Privacy policy
            </div>
          </ListItem>
        </DropDownList>
      </div>
    </>
  );
}
